import * as Logger from "js-logger";
import { GeoPoint } from "../earth/core/geoPoint";
import { EarthEngine, FrameTime } from "../earth/earthEngine";
import { Country } from "../earth/model/country";
import { Anchor } from "../earth/ui/anchor";
import { EarthTappedEvent, SkyTappedEvent } from "../earth/ui/interactionManager";
import { MetricsService } from "./services/metricsService";
import { PublicationsService } from "./services/publicationsService";
import { UIManager } from "./ui/uiManager";

import "./spinner.css";
import "./style.css";

import "./style-handheld.css";

export class Main {
    private static _instance: Main;

    static get instance(): Main {
        return Main._instance;
    }

    uiManager: UIManager;

    constructor(canvasElement: string, uiRootElement: string) {
        Main._instance = this;

        EarthEngine.instance.initialize(canvasElement);
        EarthEngine.instance.didUpdate.connect(ev => this.onUpdate(ev));
        EarthEngine.instance.interactionManager.earthTapped.connect(ev => this.onEarthTapped(ev));
        EarthEngine.instance.interactionManager.skyTapped.connect(ev => this.onSkyTapped(ev));

        MetricsService.instance.loadMetrics();
        PublicationsService.instance.loadPublications();

        this.uiManager = UIManager.renderToElement(uiRootElement);
    }

    animate(): void {
        EarthEngine.instance.engine.runRenderLoop(() => {
            EarthEngine.instance.scene.render();
        });

        window.addEventListener("resize", () => {
            EarthEngine.instance.engine.resize();
        });
    }

    private onUpdate(time: FrameTime) {
        this.uiManager.update(time);
    }

    private onEarthTapped(event: EarthTappedEvent) {
        if (!this.uiManager.onTap(event.event)) {
            this.uiManager.currentContext.onEarthTapped(event.country);
        }
    }

    private onSkyTapped(event: SkyTappedEvent) {
        if (!this.uiManager.onTap(event.event)) {
            this.uiManager.currentContext.onSkyTapped();
        }
    }
}

Logger.useDefaults();

window.addEventListener("DOMContentLoaded", () => {
    let app = new Main("renderCanvas", "uiRoot");
    app.animate();
});



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/main.ts